export default function CArraySize() {
  return <h2>C Array Size</h2>;
}
